import React, {useEffect, useMemo} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Route, Redirect, Switch } from "react-router-dom";
import AdminLayout from "../../layouts/admin/index";
import AdminClientLayout from "../../layouts/adminClient/index";
import PlansLayout from "../../layouts/plans/index";
import UsersLayout from "../../layouts/users/index";
import ClientsLayout from "../../layouts/clients/index";
import ClientsForClientPortal from "../../layouts/clientsClientPortal";
import CardLayout from "../../layouts/card/index";
import PayOrderLayout from "../../layouts/payOrder/index";
import SubscriptionLayout from "../../layouts/subscription/index";
import ConfigurationLayout from "../../layouts/configuration/index";
import ConfigurationAdminLayout from "../../layouts/configurationAdmin/index";
import PixLayout from "../../layouts/pix/index";
import DoubtsLayout from "../../layouts/doubts";
import CampaignsLayout from "../../layouts/campaigns";
import EcommerceLayout from "../../layouts/ecommerce";

//Action Functions
import { openSocket } from "../../redux/actions/socket";
import { newMessage } from "../../redux/actions/messages";
import { chatWithNewMessage } from "../../redux/actions/chatsWithNewMessages";

export default function PrivateRouteWrapper() {
  const login = useSelector((state: {login: any}) => state.login);
  const websocket = useSelector((state: {websocket: any}) => state.websocket);

  const dispatch = useDispatch();

  const type = login.user.ownersId;

  if (!login.authorized) { //login.authorized
    return <Redirect to={{ pathname: "/auth/login" }} />;
  }

  useEffect(() => {
    if(type !== null && (login.user.powerUser === false || login.user.powerUser === null)){
      dispatch(openSocket(login.user.owners.id));
    }

  }, []);
  
  useEffect(() => {
    const handleNewMessage = (data: {message: string, chatId: string}) => {
      dispatch(newMessage(
          {
              chatId: data.chatId,
              from: "user",
              text: data.message
          }
      ));
      
      dispatch(chatWithNewMessage(data.chatId));

      const audio = new Audio();
      
      audio.src = "/notification.mp3";
      audio.play();
    }
    
    if(websocket.socket !== null){
      websocket.socket.on("connect", () => {
        websocket.socket.on("receivedMessage", handleNewMessage)
      })
    }

  }, [websocket.socket])

  const getRoutesForTypeOfUser = () => {
    if(type === null || login.user.powerUser === true){   //Quer dizer que é branch
      let routesBranch = [];
      
      routesBranch.push(<Route path="/doubts" key="/doubts" render={() => <DoubtsLayout  />} />);
      routesBranch.push(<Route path="/admin/campaigns" key="/admin/campaigns" render={() => <CampaignsLayout />}/>);
      routesBranch.push(<Route path="/admin/pix" key="/admin/pix" render={() => <PixLayout/>}/>);
      routesBranch.push(<Route path="/admin/ecommerce" key="/admin/ecommerce" render={() => <EcommerceLayout/>}/>);
      routesBranch.push(<Route path="/admin/configuration" key="/admin/configuration" render={() => <ConfigurationLayout  />} />);
      routesBranch.push(<Route path="/admin/subscription" key="/admin/subscription" render={() => <SubscriptionLayout  />} />)
      routesBranch.push(<Route path="/admin/card" key="/admin/card" render={() => <CardLayout  />} />);
      routesBranch.push(<Route path="/admin/pay-order" key="/admin/pay-order" render={() => <PayOrderLayout  />} />);
      routesBranch.push(<Route path="/admin/client" key="/admin/client" render={() => <ClientsForClientPortal  />} />)
      routesBranch.push(<Route path="/admin" key="/admin" render={() => <AdminClientLayout  />} /> );
      
      return routesBranch;
    } 
    
    else {
      let routesOwner = [];
      
      routesOwner.push(<Route path="/admin/clients" key="/admin/clients" render={() => <ClientsLayout  />} />);
      routesOwner.push(<Route path="/admin/plans" key="/admin/plans" render={() => <PlansLayout  />} />);
      routesOwner.push(<Route path="/admin/users" key="/admin/users" render={() => <UsersLayout  />} />)
      routesOwner.push(<Route path="/admin/configuration" key="/admin/configuration" render={() => <ConfigurationAdminLayout  />} />);
      routesOwner.push(<Route path="/admin" key="/admin" render={() => <AdminLayout  />} />);
      
      return routesOwner;
    }
  }

  return (
    <Switch>
      {getRoutesForTypeOfUser()}
      <Redirect from="/" to="/auth/login" />
    </Switch>
  );
}
